import Image from 'next/image'

import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

type CarbonActivity = {
  image: string
  value: number
  text: string
}

const ACTIVITIES: CarbonActivity[] = [
  {
    image: '/img/icons/scenario-utilities.svg',
    text: `A typical household's annual electricity use`,
    value: 1.1
  },
  {
    image: '/img/icons/scenario-driving.svg',
    text: `Driving a medium-sized petrol car 10,000 km`,
    value: 2
  },
  {
    image: '/img/icons/scenario-flights.svg',
    text: `A return flight between Auckland and Christchurch`,
    value: 0.4
  }
]

const ActivityCard = ({ activity }: { activity: CarbonActivity }) => {
  const { image, text, value } = activity
  return (
    <div className='min-w-[260px] lg:min-w-min p-5 flex-1 flex flex-col gap-[10px] bg-white rounded-md'>
      <Image alt={`activity_co2_${value}`} src={image} width={80} height={40} />
      <span className='font-body-rebrand text-[20px] leading-[26px] font-bold text-forestDeep'>
        {value} tCO₂e
      </span>
      <span className='font-body-rebrand text-[14px] leading-[20px] font-medium max-w-full text-wrap'>
        {text}
      </span>
    </div>
  )
}

export const CarbonActivities = () => (
  <div className='flex flex-col'>
    <TypographyRebrand variant='body' color='forestDeep'>
      Don&apos;t know your carbon footprint measurement? Here are some common
      carbon-emitting activities.
    </TypographyRebrand>
    <div className='flex flex-row whitespace-nowrap overflow-x-scroll gap-5 content-between'>
      {ACTIVITIES.map((activity, idx) => (
        <ActivityCard key={`activity_${idx}`} activity={activity} />
      ))}
    </div>
  </div>
)
